import React from 'react'

import { makeStyles } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import useCategories from '../hooks/useCategories'

const useStyle = makeStyles({
  root: {
    textTransform: 'lowercase',
    '&:first-letter': {
      textTransform: 'uppercase',
    },
  },
})

const LawyerDomain = ({ lawyerToDisplay, style = {} }) => {
  const { categories } = useCategories()

  const classes = useStyle()

  const getParentName = (categoryId) => {
    const domaine = categories.find((c) => c._id === categoryId)

    if (!domaine) return ''

    const parentDomain = categories.find((c) => c._id === domaine.idParent)

    return parentDomain?.name || ''
  }

  return (
    <div className={classes.root} style={style}>
      <FormattedMessage
        id={'SearchBar.subLawyer'}
        defaultMessage={'{gender, select, male {Avocat} female {Avocate}} en {domain}'}
        values={{
          gender: 'male',
          domain: [...new Set(lawyerToDisplay.skills?.map((i) => getParentName(i)))]
            .filter((i) => !!i)
            .join(', '),
        }}
      />
    </div>
  )
}

export default LawyerDomain
